var module; UMD(module, {
  'minted:m': ['M']
})(this, function (m_module) {

var M = m_module.M;

M.Config = M.Config || {};

M.Config['EventConfig'] =
{
  "type": {
    "all": {
      "id": 1
    },
    "request_feedback_design": {
      "id": 1004
    },
    "like_design": {
      "id": 1000
    },
    "comment_on_design": {
      "id": 1001
    },
    "submit_design": {
      "id": 1002
    },
    "poll_design": {
      "id": 1003
    },
    "user_message_to_service_discussion": {
      "id": 5000
    },
    "system_message_to_service_discussion": {
      "id": 5001
    }
  }
};

return {};

});

